import { DisclaimerMessage } from './components/DisclaimerMessage';

export { DisclaimerMessage };
